import axios from "axios";
import { toast } from "react-toastify";


const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const addToCart = async ({
  product_auto_id,
  added_by_id,
  cart_quantity,
  size,
  size_price,
  cust_image,
}) => {
  try {
    const accessToken = sessionStorage.getItem("accessToken");
    if (!accessToken) {
      throw new Error("Please log in first.");
    }

    const admin_auto_id = sessionStorage.getItem("admin_auto_id");
    const user_auto_id = accessToken;
    const userPincode = sessionStorage.getItem("userPincode");

    const payload = {
      product_auto_id,
      admin_auto_id,
      user_auto_id,
      added_by_id,
      cart_quantity: String(cart_quantity),
      pincode: userPincode,
    };

    if (size) payload.size = size;
    if (size_price) payload.size_price = size_price;

    if (cust_image) {
      const formData = new FormData();
      Object.keys(payload).forEach((key) => formData.append(key, payload[key]));
      formData.append("cust_image", cust_image);
      const response = await axios.post(`${BASE_URL}/add_to_cart`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const res = response.data;
      if (res.status === "1") {
        return { ...res, message: "Product added to cart successfully!" };
      } else if (
        res.status === "0" &&
        res.msg === "Product already added in cart"
      ) {
        return { ...res, message: "Product is already in your cart." };
      } else {
        return { ...res, message: res.msg };
      }
    } else {
      const response = await axios.post(`${BASE_URL}/add_to_cart`, payload);
      const res = response.data;
      if (res.status === "1") {
        window.dispatchEvent(new Event("cart-updated"));
        return { ...res, message: "Product added to cart successfully!" };
      } else if (
        res.status === "0" &&
        res.msg === "Product already added in cart"
      ) {
        return { ...res, message: "Product is already in your cart." };
      } else {
        return { ...res, message: res.msg };
      }
    }
  } catch (error) {
    throw new Error(error.message || "Failed to add product to cart.");
  }
};

export const removeFromCart = async (
  product_auto_id
) => {
  try {
    const admin_auto_id = sessionStorage.getItem("admin_auto_id");
     const user_auto_id = sessionStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("product_auto_id", product_auto_id);
    formData.append("admin_auto_id", admin_auto_id);
    formData.append("user_auto_id", user_auto_id);

    const response = await axios.post(`${BASE_URL}/delete_from_cart`, formData);

    if (response.data.status === 1) {
      window.dispatchEvent(new Event("cart-updated"));
      console.log("Removed from Cart Successfully");
    } else {
      toast.warning(response.data.msg || "Failed to remove from cart");
    }
  } catch (error) {
    console.log("Error removing from cart");
    console.error("Remove from Cart Error:", error);
  }
};


export const getCartCount = async () => {
  try {
    const admin_auto_id = sessionStorage.getItem("admin_auto_id");
    const user_auto_id = sessionStorage.getItem("accessToken");

    if (!user_auto_id || !admin_auto_id) {
      return 0;
    }

    const response = await axios.post(`${BASE_URL}/get_cart_product_count`, {
      admin_auto_id,
      user_auto_id,
    });

    if (response.data.status === 1) {
      return response.data.product_count_data;
    } else {
      return 0;
    }
  } catch (error) {
    console.error("Error fetching cart count:", error);
    return 0;
  }
};


export const editCartProduct = async ({
  cart_product_auto_id,
  cart_quantity,
  size,
}) => {
  try {
    const admin_auto_id = sessionStorage.getItem("admin_auto_id");
    const user_auto_id = sessionStorage.getItem("accessToken");

    if (!admin_auto_id || !user_auto_id) {
      throw new Error("User not logged in");
    }

    const response = await axios.post(
      `${BASE_URL}/edit_cart_product`,
      {
        cart_product_auto_id,
        cart_quantity,
        size,
      }
    );

    if (response.data.status === "1" || response.data.status === 1) {
      window.dispatchEvent(new Event("cart-updated"));
      return response.data;
    } else {
      throw new Error(response.data.msg || "Failed to update cart");
    }
  } catch (error) {
    console.error("Edit cart error:", error);
    toast.error(error.message || "Failed to update cart");
    throw error;
  }
};


export const getCartProducts = async () => {
  const admin_auto_id = sessionStorage.getItem("admin_auto_id");
  const user_auto_id = sessionStorage.getItem("accessToken");

  if (!admin_auto_id || !user_auto_id) return [];

  try {
    const res = await axios.post(
      `${BASE_URL}/get_cart_list`,
      {
        admin_auto_id,
        user_auto_id,
      }
    );

    if (res.data.status === 1) {
      return res.data.cart_product_data || [];
    }

    return [];
  } catch (err) {
    console.error("Get cart products error", err);
    return [];
  }
};